<template>
<div class="Bldg" :style="style">
    <div class="windows">
    <Window v-for="window in windows" :key="window" />
    </div>
    
    <div class="door" :style="doorPos">
    </div>
</div>    
</template>
<script>
import Window from './window.vue';
import math from './mixins/math';
export default {
    mixins:[math],
    components:{
        Window
    },
    props: ["properties"],
    computed:{
        style: function(){
            return {
                width: this.properties.width +'px',
                height: this.properties.height +'px',
                'margin-left': this.properties.leftMargin +'px',
                'border-top-left-radius': this.properties.radius +'px',
                'border-top-right-radius': this.properties.radius +'px'
            }
        },
        wincount: function(){
            return this.randomRange(8,12);
        },
        windows: function(){
            var win = [];
            for(let i=0; i<this.wincount;i++) win.push(i);
            return win;
        },
        doorPos: function(){
            return{
                "margin-left": this.randomRange(10,50)+'%',
                'margin-top': ((this.properties.height * 0.3) - 20) + 'px'
            }
        }
    }
}
</script>
<style>
.Bldg{
    display: inline-block;
    position: relative;
    background-color: rgb(24, 2, 102);
    margin-top: 200px;
    border: 0px solid;
    overflow: hidden;
}
.windows{
    overflow: hidden;
    height: 70%;
}
.door{
    align-self: flex-end;
    display: inline-block;
    position: absolute;
    background-color: dimgrey;
    height: 20px;
    width: 10px;
}
</style>